module.exports = __webpack_public_path__ + "static/img/应用场景6-预警事件记录.7167783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/应用场景6-预警事件记录.png
// module id = CdPH
// module chunks = 0